'use es6';

import { Record } from 'immutable';
import { AdWordsConversionTrackerCategory, AdWordsConversionTrackerStatus, AdWordsTrackingCodeType, AdWordsCountingType, AdWordsConversionTrackerType, AdWordsAppPlatform, AdWordsAppConversionType } from '../../lib/Constants';
export const AdWordsConversionTrackerEntityRecord = Record({
  id: null,
  originalConversionTypeId: null,
  ownerId: null,
  name: null,
  status: AdWordsConversionTrackerStatus.ENABLED,
  // For trackingCodeType of CLICK_TO_CALL this default is actuall LEAD
  // but not gonna bother encoding that here.
  category: AdWordsConversionTrackerCategory.DEFAULT,
  viewthroughLookbackWindow: 30,
  ctcLookbackWindow: 30,
  countingType: AdWordsCountingType.MANY_PER_CLICK,
  value: null,
  currency: null,
  alwaysUseDefaultValue: true,
  excludeFromBidding: false,
  mostRecentConversionDate: null,
  trackerType: AdWordsConversionTrackerType.AdWordsConversionTracker,
  snippet: null,
  textformat: null,
  conversionPageLanguage: null,
  backgroundColor: null,
  trackingCodeType: AdWordsTrackingCodeType.WEBPAGE
});
export const AdWordsAppConversionTrackerEntityRecord = Record({
  id: null,
  originalConversionTypeId: null,
  ownerId: null,
  name: null,
  status: AdWordsConversionTrackerStatus.ENABLED,
  category: AdWordsConversionTrackerCategory.PURCHASE,
  viewthroughLookbackWindow: null,
  ctcLookbackWindow: 30,
  countingType: AdWordsCountingType.MANY_PER_CLICK,
  value: null,
  currency: null,
  alwaysUseDefaultValue: true,
  excludeFromBidding: false,
  mostRecentConversionDate: null,
  trackerType: AdWordsConversionTrackerType.AppConversion,
  appId: null,
  appPlatform: AdWordsAppPlatform.GOOGLE_PLAY,
  snippet: null,
  appConversionType: AdWordsAppConversionType.DOWNLOAD,
  appPostbackUrl: null
});
export const AdWordsUploadConversionTrackerEntityRecord = Record({
  id: null,
  originalConversionTypeId: null,
  ownerId: null,
  name: null,
  status: AdWordsConversionTrackerStatus.ENABLED,
  category: AdWordsConversionTrackerCategory.DEFAULT,
  viewthroughLookbackWindow: null,
  ctcLookbackWindow: 90,
  countingType: AdWordsCountingType.MANY_PER_CLICK,
  value: null,
  currency: null,
  alwaysUseDefaultValue: true,
  excludeFromBidding: false,
  mostRecentConversionDate: null,
  trackerType: AdWordsConversionTrackerType.UploadConversion
});
export const AdWordsWebsiteCallMetricsConversionTrackerEntityRecord = Record({
  id: null,
  originalConversionTypeId: null,
  ownerId: null,
  name: null,
  status: AdWordsConversionTrackerStatus.ENABLED,
  category: AdWordsConversionTrackerCategory.LEAD,
  viewthroughLookbackWindow: null,
  ctcLookbackWindow: 30,
  countingType: AdWordsCountingType.ONE_PER_CLICK,
  value: null,
  currency: null,
  alwaysUseDefaultValue: true,
  excludeFromBidding: false,
  mostRecentConversionDate: null,
  trackerType: AdWordsConversionTrackerType.WebsiteCallMetricsConversion,
  phoneCallDuration: 60,
  snippet: null
});
export const AdWordsAdCallMetricsConversionTrackerEntityRecord = Record({
  id: null,
  originalConversionTypeId: null,
  ownerId: null,
  name: null,
  status: AdWordsConversionTrackerStatus.ENABLED,
  category: AdWordsConversionTrackerCategory.LEAD,
  viewthroughLookbackWindow: null,
  ctcLookbackWindow: 30,
  countingType: AdWordsCountingType.MANY_PER_CLICK,
  value: null,
  currency: null,
  alwaysUseDefaultValue: true,
  excludeFromBidding: false,
  mostRecentConversionDate: null,
  trackerType: AdWordsConversionTrackerType.AdCallMetricsConversion,
  phoneCallDuration: 60
});
export const TrackerTypeToRecord = {
  [AdWordsConversionTrackerType.AdWordsConversionTracker]: AdWordsConversionTrackerEntityRecord,
  [AdWordsConversionTrackerType.UploadConversion]: AdWordsUploadConversionTrackerEntityRecord,
  [AdWordsConversionTrackerType.AdCallMetricsConversion]: AdWordsAdCallMetricsConversionTrackerEntityRecord,
  [AdWordsConversionTrackerType.AppConversion]: AdWordsAppConversionTrackerEntityRecord,
  [AdWordsConversionTrackerType.WebsiteCallMetricsConversion]: AdWordsWebsiteCallMetricsConversionTrackerEntityRecord
};